

export const url_login = process.env.REACT_APP_URL_LOGIN
// export const url_login = "https://api.vulpes.pt/"
export const url = process.env.REACT_APP_URL
export const url_faturas = process.env.REACT_APP_URL_FATURAS
// export const url = "https://api.vulpes.pt/cadernos_dev/"
// export const url_login = "https://api.vulpes.pt/"
export const logos = process.env.REACT_APP_LOGOS
export const docs_cadernos = process.env.REACT_APP_DOCS_CADERNOS

